import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MarkMessageUnreadSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MarkMessageUnreadSVG;
